import { createAction, createAsyncAction } from 'typesafe-actions';

export const placeSystemBetAsync = createAsyncAction(
    '@batch-betting/PLACE_BET_REQUEST',
    '@batch-betting/PLACE_BET_SUCCESS',
    '@batch-betting/PLACE_BET_FAILURE'
)<undefined, any, string>();

export const cleanSystemBet = createAction('@batch-betting/CLEAN_BET')();
